<template>
  <!-- Importing Help Component -->
  <HelpComp></HelpComp>
</template>
<script>
import HelpComp from "../components/Help.vue";

export default {
  name: "Help",
  components: { HelpComp },
  computed: {},
  mounted() {},
};
</script>
